
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 160 160"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M106 93v-4.5a6.5 6.5 0 016.5-6.5 6.5 6.5 0 016.5 6.5v24.611C119 126.857 107.857 138 94.111 138H82.206a25.294 25.294 0 01-19.801-9.555l-19.67-24.747a6.726 6.726 0 01.509-8.942 6.726 6.726 0 019.512 0L63 105V51a7 7 0 017-7 7 7 0 017 7v37-6.5a7.5 7.5 0 017.5-7.5 7.5 7.5 0 017.5 7.5V90v-5a7 7 0 017-7 7 7 0 017 7v8zM50 31l7 7m33-7l-7 7M70 22v11","fill":"none","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    